// extracted by mini-css-extract-plugin
export var button = "sharedTextButton-module--button--MhVUt";
export var green = "sharedTextButton-module--green--UesQw";
export var icon = "sharedTextButton-module--icon--KC1io";
export var lightGreen = "sharedTextButton-module--light-green--v9I1j";
export var small = "sharedTextButton-module--small--OKkfV";
export var white = "sharedTextButton-module--white--6o19J";